<template>
    <div>
    <el-dialog :title="evaluateInfo ? '防水服务评价' : '防水验收单'" :visible="visibleAcceptanceOrder" width="50%"
        @close="closeDialog" :close-on-click-modal="false" append-to-body>
        <div class="container">
            <!-- <div class="dynamic-cards" v-if="customsData">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>费用清单:</span>
                    </div>
                    <el-table :data="customsData.info" style="width: 100%" border>
                        <el-table-column prop="name" label="项目"></el-table-column>
                        <el-table-column prop="value" label="数量"></el-table-column>
                        <el-table-column prop="customerPrice" label="客户单价"></el-table-column>
                        <el-table-column prop="customerTotalPrice" label="客户总价"></el-table-column>
                    </el-table>
                    <el-row>
                        <el-col :span="24">
                            <p>客户总价: {{ customsData.customerTotalPrice }}</p>
                        </el-col>
                    </el-row>
                    <el-table :data="customsData.info" style="width: 100%" border>
                        <el-table-column prop="name" label="项目"></el-table-column>
                        <el-table-column prop="value" label="数量"></el-table-column>
                        <el-table-column v-if="customsData.decorationCompany == 'YES'" prop="decorationCompanyPrice"
                            label="装饰公司单价"></el-table-column>
                        <el-table-column v-else prop="merchantPrice" label="商家单价"></el-table-column>
                        <el-table-column v-if="customsData.decorationCompany == 'YES'"
                            prop="decorationTotalCompanyPrice" label="装饰公司总价"></el-table-column>
                        <el-table-column v-else prop="merchantTotalPrice" label="商家总价"></el-table-column>
                    </el-table>
                    <el-row>
                        <el-col v-if="customsData.decorationCompany == 'YES'" :span="24">
                            <p>装饰公司总价：{{ customsData.decorationCompanyTotalPrice }}</p>
                        </el-col>
                        <el-col v-else :span="24">
                            <p>商家总价：{{ customsData.merchantTotalPrice }}</p>
                        </el-col>
                    </el-row>
                </el-card>
            </div> -->
            <div class="fixed-cards">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>验收单详情:</span>
                    </div>
                    <div class="card-content">
                        <el-row v-if="dynamicColumns.length > 0">
                            <el-col v-for="column in dynamicColumns" :key="column.id"
                                style="display: flex;align-items: center;text-align: center;"
                                :span="getSpan(dynamicColumns.length)">
                                <strong>{{ column.fieldName }}:</strong>
                                <span v-if="['input', 'checkbox', 'radio'].includes(column.inputType)">{{
        column.fieldValue }}</span>
                                <!-- 评分星级 -->
                                <span v-else-if="column.inputType === 'star'"
                                    style="display: flex;align-items: center;text-align: center;">
                                    <el-rate v-model="column.fieldValue" disabled></el-rate>
                                    <span>{{ column.fieldValue == '1' ? '差' : column.fieldValue == '2' ? '一般' :
        column.fieldValue == '3' ? '好' : column.fieldValue == '4' ? '很好' :
            column.fieldValue
                == '5' ? '非常好' : '' }}</span>
                                </span>
                                <span v-else><time>{{ column.fieldValue }}</time></span>
                            </el-col>
                        </el-row>
                        <el-row v-if="dynamicColumns.length === 0">
                            <el-col :span="24">
                                <p>暂无数据</p>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </div>
            <div class="dynamic-cards" v-if="imageFields.length > 0">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>工单清单图片信息:</span>
                    </div>
                    <div class="form-row" v-for="column in imageFields" :key="column.id">
                        <p class="gap-line-border" v-if="column.inputType === 'img'">
                            <span class="nameStyle">{{ column.fieldName }}:</span>
                            <span class="gap-line"></span>
                            <span v-if="column.fieldValue">
                                <viewer :images="formmaterImage(column.fieldValue)">
                                    <img v-for="src in formmaterImage(column.fieldValue)" :src="src" :key="src"
                                        class="card-image" />
                                </viewer>
                            </span>
                            <span v-else>暂无图片</span>
                        </p>
                    </div>
                </el-card>
            </div>
            <div class="dynamic-cards" v-if="info.signUrl">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>验收签名:</span>
                    </div>
                    <div class="form-row">
                        <p class="gap-line-border">
                            <span class="nameStyle">签名时间：{{ info.signTime }}</span>
                            <span class="gap-line"></span>
                            <span v-if="info.signUrl">
                                <viewer :images="formmaterImage(info.signUrl)">
                                    <img :src="info.signUrl" class="card-image" />
                                </viewer>
                            </span>
                            <span v-else>暂无图片</span>
                        </p>
                    </div>
                </el-card>
            </div>
            <div class="dynamic-cards" v-if="historyReasons">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>历史退回原因:</span>
                    </div>
                    <div class="form-row" v-for="(remark, index) in historyReasons.split(',')" :key="index">
                        <p class="gap-line-border">
                            <span> <span class="nameStyle">第{{ index + 1 }}次退回原因:</span>{{ remark }}</span>
                            <span class="gap-line"></span>
                        </p>
                    </div>
                </el-card>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="text" icon="el-icon-check" size="small" plain v-if="info.status == 'TO_BE_THE_FINAL'"
                @click.stop="pass()">通过</el-button>
            <el-button type="text" icon="el-icon-close" size="small" plain v-if="info.status == 'TO_BE_THE_FINAL'"
                @click.stop="refuse()">拒绝</el-button>
            <el-button v-if="info.status != 'TO_BE_THE_FINAL'" type="text" size="small" icon="el-icon-close" plain
                @click="closeDialog">关闭</el-button>
        </span>
    </el-dialog>
    <!-- 输入代金券弹窗 -->
    <el-dialog title="输入代金券" :visible.sync="showCostInputdialog" width="30%" append-to-body :close-on-click-modal="false">
        <el-form :model="printForm" ref="costForm" label-width="120px">
            <el-form-item label="代金券金额" prop="voucher">
                <el-input v-model="printForm.voucher" type="number" min="0" placeholder="请输入代金券金额" />
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button type="primary" @click="confirmCostInput">确认</el-button>
            <el-button @click="cancelCostInput">取消</el-button>
        </span>
    </el-dialog>
    </div>
</template>

<script>
import { evaluateInfoView } from "@/api/salesCloud/preFilter";
import { findDataSourceFields } from "@/api/work/dynamicForm";
import { passOrRefusedAcceptance, findCustomsDeclaration, getWaterProofStage } from "@/api/work/waterProof/merchants";
import { findEngineeringOrder, getPrintCount } from "@/api/work/eliveryOrder";
import { DIC } from "@/const/dic";
import { formatterTime } from "@/util/util";
export default {
    name: "ViewServiceDiary",
    props: {
        visibleAcceptanceOrder: {
            type: Boolean,
            required: true,
        },
        orderId: {
            type: [String, Number],
            required: true,
        },
        evaluateInfo: {
            type: Boolean,
            default: false,
        },
        infoDetail: {
            type: Object,
            default: () => ({}),
        },
        id: {
            type: [String, Number],
            default: '',
        },
    },
    data() {
        return {
            tableData: [], // 存放固定字段数据
            dynamicColumns: [], // 存放动态字段列数据
            imageFields: [], // 存放动态图片字段数据
            inputTypes: [], // 获取动态控件类型
            type: '',
            info: {},
            historyReasons: '',
            customsData: null,
            costDataList: [], // 防水阶段费用数据列表
            loadingCost: false, // 费用数据加载状态
            showCostInputdialog: false, // 代金券弹窗
            printForm: {
                voucher: '' // 代金券金额
            },
        };
    },
    created() {
        // 初始加载时如果 orderId 已经有值，调用 handleList
        if (this.orderId) {
            // 获取动态控件类型
            findDataSourceFields().then(res => {
                let data = JSON.parse(res.data);
                this.inputTypes = data;

                // 获取产品数据
                const orderId = this.orderId; // 假设产品ID通过路由参数传递
                if (orderId) {
                    this.fetchGoodsData(orderId);
                }
            }).catch(err => {
                this.$message.error('获取动态控件类型失败', err);
            });
        }
    },
    watch: {
        /**
         * 
         * @param newVal 
         * @description 监听 visibleAcceptanceOrder 的变化
         * @returns void
         */
        visibleAcceptanceOrder(newVal) {
            if (newVal && this.orderId) {
                // 获取动态控件类型
                findDataSourceFields().then(res => {
                    let data = JSON.parse(res.data);
                    this.inputTypes = data;

                    // 获取产品数据
                    const orderId = this.orderId; // 假设产品ID通过路由参数传递
                    if (orderId) {
                        this.fetchGoodsData(orderId);
                        // this.findCustomsDeclaration();
                    }
                }).catch(err => {
                    this.$message.error('获取动态控件类型失败', err);
                });
            }
        }
    },
    methods: {
        pass() {
            this.$confirm("确认通过？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let data = { ...this.info }
                    data.status = 'TO_BE_CONFIRMED';
                    passOrRefusedAcceptance(data).then((res) => {
                        if (res.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "操作成功",
                                type: "success",
                            });
                            this.$emit('refresh');
                            this.closeDialog();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
                })
                .catch(() => { });
        },
        refuse() {
            this.$prompt("请输入拒绝原因", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPattern: /^.{1,255}$/,
                inputErrorMessage: "请输入正确长度的拒绝原因1-255",
            })
                .then(({ value }) => {
                    let data = { ...this.info }
                    data.status = 'IN_SERVICE';
                    data.reason = this.historyReasons ? this.historyReasons + ',' + value : value;
                    passOrRefusedAcceptance(data).then((response) => {
                        if (response.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "操作成功",
                                type: "success",
                            });
                            this.$emit('refresh');
                            this.closeDialog();
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        showClose: true,
                        message: "提交出错",
                        type: "error",
                    });
                });
        },
        findCustomsDeclaration() {
            findCustomsDeclaration(this.id).then(res => {
                if (res.code === "200") {
                    this.customsData = JSON.parse(res.data);
                    console.log('this.customsData::: ', this.customsData);

                } else {
                    this.$message.error(res.message);
                }
            });
        },
        /**
         * 
         * @param orderId 工单ID
         * @description 获取工单数据
         * @returns void
         */
        fetchGoodsData(orderId) {
            const params = {
                id: orderId,
                code: this.evaluateInfo ? 'AFTER_SALES_EVALUATION' : 'WATERPROOF_ACCEPTANCE'
            };
            findEngineeringOrder(this.orderId).then(res => {
                if (res.code === "200") {
                    const data = JSON.parse(res.data).rows[0];
                    data.signTime = data.signTime?formatterTime(data.signTime):'';
                    this.info = data;
                    if (data.reason) {
                        this.historyReasons = data.reason;
                    }
                    console.log('this.info',this.info);
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            });
            // 获取产品数据
            evaluateInfoView(params).then(res => {
                if (res.code == "200") {
                    const jsonData = JSON.parse(res.data); // 解析返回的 JSON 数据
                    // 将图片字段单独处理
                    const imageFields = jsonData.list.filter(item => item.inputType == '8').map(item => ({
                        id: item.id,
                        fieldName: item.fieldName,
                        inputType: this.getInputType(item.inputType), // 获取输入类型
                        fieldValue: item.value
                    }));
                    this.imageFields = imageFields;
                    // 其他字段
                    const dynamicColumns = jsonData.list.filter(item => item.inputType != '8').map(item => ({
                        id: item.id,
                        fieldName: item.fieldName,
                        inputType: this.getInputType(item.inputType), // 获取输入类型
                        fieldValue: item.dataType.word == 'star' ? parseInt(item.value) : item.value
                    }));
                    this.dynamicColumns = dynamicColumns;
                    console.log('this.dynamicColumns:::1 ', this.dynamicColumns);

                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            }).catch(err => {
                this.$message.error('获取数据失败', err);
            });
        },
        /**
         * 
         * @param length 
         * @description 动态计算每列的span值
         * @returns number
         */
        getSpan(length) {
            // 动态计算每列的span值
            return Math.floor(24 / Math.min(length, 3)); // 最多3列
        },
        /**
         * 
         * @param row 
         * @description 格式化图片字段
         * @returns Array
         */
        formmaterImage(row) {
            let str = new Array();
            if (row != null) {
                let picArray = row.split(",");
                for (let i = 0; i < picArray.length; i++) {
                    str.push(picArray[i]);
                }
            }
            return str;
        },
        /**
         * 
         * @param inputType 
         * @description 获取输入类型的名称
         * @returns string
         */
        getInputType(inputType) {
            const item = this.inputTypes.find(type => type.id == inputType);
            return item ? item.word : ''; // 返回输入类型的名称
        },
        /**
         * 
         * @param status 
         * @description 获取状态的名称
         * @returns string
         */
        getStatusLabel(status) {
            const statusItem = DIC.PRE_FILTER_STATUS.find(item => item.value === status);
            return statusItem ? statusItem.label : status;
        },
        /**
         * 
         * @description 关闭弹窗
         * @returns void
         */
        closeDialog() {
            console.log('closeDialog');
            this.$emit("update:visibleAcceptanceOrder", false);
        },
        // 销售出库单打印 - 外部调用入口
        async handlePrintOutbound() {
            /* // 加载报单基础信息
            if (!this.info || !this.info.id) {
                try {
                    const res = await findEngineeringOrder(this.orderId);
                    if (res.code === "200") {
                        const data = JSON.parse(res.data).rows[0];
                        data.signTime = data.signTime ? formatterTime(data.signTime) : '';
                        this.info = data;
                    }
                } catch (e) {
                    console.error('获取报单信息失败', e);
                }
            } */
            // 加载阶段费用数据
            if (!this.costDataList || this.costDataList.length === 0) {
                await this.loadCostData();
            }
            if (!this.costDataList || this.costDataList.length === 0) {
                this.$message.warning('暂无阶段费用数据，无法打印');
                return;
            }
            this.printForm.voucher = '';
            this.showCostInputdialog = true;
        },
        // 加载防水阶段费用数据
        loadCostData() {
            this.loadingCost = true;
            return getWaterProofStage(this.id || this.orderId).then(res => {
                if (res.code == "200") {
                    const parsedData = JSON.parse(res.data);
                    this.costDataList = Array.isArray(parsedData) ? parsedData : [parsedData];
                } else {
                    this.costDataList = [];
                }
            }).catch(() => {
                this.costDataList = [];
            }).finally(() => {
                this.loadingCost = false;
            });
        },
        // 确认代金券输入
        confirmCostInput() {
            this.showCostInputdialog = false;
            this.printOutbound();
        },
        // 取消代金券输入
        cancelCostInput() {
            this.printForm.voucher = '';
            this.showCostInputdialog = false;
            this.$nextTick(() => {
                if (this.$refs.costForm) {
                    this.$refs.costForm.clearValidate();
                }
            });
        },
        // 执行打印
        async printOutbound() {
            // 汇总所有阶段的工费明细
            const allRows = [];
            let grandTotal = 0;
            this.costDataList.forEach(stage => {
                if (stage.costDetails && stage.costDetails.length > 0) {
                    stage.costDetails.forEach(item => {
                        allRows.push({ ...item, stageName: stage.goodsName || '' });
                    });
                }
                grandTotal += Number(stage.y || 0);
            });
            if (allRows.length === 0) {
                this.$message.warning('暂无工费明细数据');
                return;
            }
            const params = { orderId: this.orderId, count: 0 };
            let currentPrintCount = 0;
            try {
                const res = await getPrintCount(params);
                if (res.code == "200") {
                    currentPrintCount = Number(res.data) || 0;
                }
            } catch (err) {
                console.error('获取打印次数失败', err);
            }
            const printWindow = window.open('', '_blank');
            const printTime = new Date().toLocaleString();
            let printContent = `
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <style>
                        * { margin: 0; padding: 0; box-sizing: border-box; }
                        body { font-family: "SimHei", "黑体", sans-serif; font-size: 12pt; line-height: 1.4; color: #000; background: #fff; }
                        .print-container { width: 100%; max-width: 210mm; margin: 0 auto; padding: 12mm; box-sizing: border-box; }
                        .header { text-align: center; }
                        .header h1 { font-size: 16pt; font-weight: bold; margin-bottom: 4mm; font-family: "SimHei", "黑体", sans-serif; }
                        .basic-info { margin-bottom: 5mm; }
                        .info-row { display: flex; margin-bottom: 4mm; align-items: center; line-height: 1.4; }
                        .info-item { flex: 1; font-size: 13pt; }
                        .info-label { font-weight: bold; min-width: 80px; font-size: 13pt; }
                        .table-container { margin-bottom: 2mm; }
                        .table-container h2 { font-size: 12pt; font-weight: bold; margin-bottom: 1mm; text-align: center; font-family: "SimHei", "黑体", sans-serif; }
                        table { width: 100%; border-collapse: collapse; margin-bottom: 2mm; }
                        th, td { border: 1px solid #000; padding: 2mm; text-align: center; font-size: 12pt; line-height: 1.3; }
                        th { font-weight: bold; font-family: "SimHei", "黑体", sans-serif; }
                        .total-row { font-weight: bold; }
                        .footer { text-align: right; font-size: 12pt; }
                        @media print {
                            @page { size: A4; margin: 2mm; }
                            body { font-size: 12pt; }
                            .header h1 { font-size: 16pt; }
                            .table-container h2 { font-size: 12pt; }
                            th, td { font-size: 12pt; }
                            .info-item, .info-label { font-size: 12pt; }
                            .footer { font-size: 12pt; }
                            .print-container { page-break-inside: avoid; }
                        }
                    </style>
                </head>
                <body>
                    <div class="print-container">
                        <div class="header">
                            <h1>销售出库单</h1>
                        </div>
                        <div class="basic-info">
                            <div class="info-row">
                                <div class="info-item">
                                    <span class="info-label">客户简称:</span> ${this.info.abbreviation || '无'}
                                </div>
                                <div class="info-item">
                                    <span class="info-label">报单编号:</span> ${(this.infoDetail && this.infoDetail.number) || this.info.number || '无'}
                                </div>
                            </div>
                            <div class="info-row">
                                <div class="info-item">
                                    <span class="info-label">客户全称:</span> ${(this.infoDetail && this.infoDetail.shopName) || this.info.shopName || '无'}
                                </div>
                                <div class="info-item">
                                    <span class="info-label">户型:</span> ${(this.infoDetail && this.infoDetail.houseType) || this.info.houseType || '无'}
                                </div>
                            </div>
                            <div class="info-row">
                                <div class="info-item">
                                    <span class="info-label">业务员:</span> ${(this.infoDetail && this.infoDetail.introducer) || this.info.introducer || '无'}
                                </div>
                                <div class="info-item">
                                    <span class="info-label">装饰公司:</span> ${(this.infoDetail && this.infoDetail.paymentTarget) || this.info.paymentTarget || '无'}
                                </div>
                            </div>
                            <div class="info-row">
                                <div class="info-item">
                                    <span class="info-label">报单时间:</span> ${((this.infoDetail && this.infoDetail.createTime) || this.info.createTime) ? this.formatterTime((this.infoDetail && this.infoDetail.createTime) || this.info.createTime) : '无'}
                                </div>
                                <div class="info-item">
                                    <span class="info-label">交付时间:</span> ${this.infoDetail.auditTime ? this.formatterTime(this.infoDetail.auditTime) : '无'}
                                </div>
                            </div>
                            <div class="info-row">
                                <div class="info-item">
                                    <span class="info-label">交付地址:</span> ${(this.infoDetail && this.infoDetail.customAddress) || this.info.customAddress || '无'}
                                </div>
                            </div>
                        </div>
                        <div class="table-container">
                            <table>
                                <thead>
                                    <tr>
                                        <th>序号</th>
                                        <th>项目</th>
                                        <th>单位</th>
                                        <th>数量</th>
                                        <th>单价</th>
                                        <th>金额</th>
                                        <th>备注</th>
                                    </tr>
                                </thead>
                                <tbody>
            `;
            const unitMap = {
                '面积': '平方',
                '基坑': '个',
                '回填': '个',
                '个数': '个',
                '增项': '其它',
                '费': '元',
                '价': '元/平方',
                '步梯楼层数': '楼',
                '公里': '公里',
            };
            allRows.forEach((item, idx) => {
                printContent += `
                    <tr>
                        <td>${idx + 1}</td>
                        <td>${item.name || ''}</td>
                         <td>${unitMap[Object.keys(unitMap).find(key => item.name.includes(key))] || item.unit || '无'}</td>
                        <td>${item.num || 0}</td>
                        <td>${item.price || 0}</td>
                        <td>${item.totalPrice || 0}</td>
                        <td>${item.remark || ''}</td>
                    </tr>
                `;
            });
            const voucher = this.printForm.voucher ? Number(this.printForm.voucher) : 0;
            printContent += `
                                    <tr class="total-row">
                                        <td colspan="5">费用合计:${this.numberToUpperCase(grandTotal)}</td>
                                        <td>${grandTotal}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="footer" style="text-align: left;">
                            <p>${voucher > 0 ? '摘要: 代金券' + voucher + ',实收金额' + (grandTotal - voucher) : ''}</p>
                        </div>
                        <div class="footer">
                            <p>打印时间: ${printTime}</p>
                            <p>打印次数: ${Number(currentPrintCount) + 1}次</p>
                        </div>
                    </div>
                </body>
                </html>
            `;
            printWindow.document.write(printContent);
            printWindow.document.close();
            printWindow.onload = function () {
                printWindow.print();
            };
            printWindow.addEventListener('afterprint', () => {
                printWindow.close();
                this.$nextTick(() => {
                    this.$confirm('是否打印成功?', '提示', {
                        confirmButtonText: '是',
                        cancelButtonText: '否',
                        type: 'warning'
                    }).then(() => {
                        this.recordPrintCount(this.orderId, 1);
                    }).catch(() => {
                        this.recordPrintCount(this.orderId, 0);
                    });
                });
            });
            this.$nextTick(() => {
                this.printForm.voucher = '';
                if (this.$refs.costForm) {
                    this.$refs.costForm.clearValidate();
                }
            });
        },
        // 记录打印次数
        recordPrintCount(orderId, success) {
            getPrintCount({ orderId: orderId, count: success }).then(() => {
            }).catch(() => {
            });
        },
        // 金额数字转大写
        numberToUpperCase(money) {
            if (money === '' || money === null || money === undefined) return '零元整';
            let num = Number(money);
            if (isNaN(num)) return '无效金额';
            let isNegative = false;
            if (num < 0) {
                isNegative = true;
                num = Math.abs(num);
            }
            num = num.toFixed(2);
            const digitChinese = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
            const unit = ['', '拾', '佰', '仟', '万', '拾', '佰', '仟', '亿', '拾', '佰', '仟', '万'];
            const decimalUnit = ['角', '分'];
            const [integerPart, decimalPart] = num.split('.');
            let integerStr = '';
            let decimalStr = '';
            if (integerPart !== '0') {
                const integerArr = integerPart.replace(/^0+/, '').split('');
                const len = integerArr.length;
                for (let i = 0; i < len; i++) {
                    const digit = parseInt(integerArr[i]);
                    const pos = len - 1 - i;
                    if (digit === 0) {
                        if (i < len - 1 && parseInt(integerArr[i + 1]) !== 0) {
                            integerStr += digitChinese[0];
                        }
                    } else {
                        integerStr += digitChinese[digit] + unit[pos];
                    }
                }
            } else {
                integerStr = digitChinese[0];
            }
            integerStr += '元';
            if (decimalPart === '00') {
                decimalStr = '整';
            } else {
                const jiao = parseInt(decimalPart[0]);
                const fen = parseInt(decimalPart[1]);
                if (jiao !== 0) {
                    decimalStr += digitChinese[jiao] + decimalUnit[0];
                } else if (fen !== 0) {
                    decimalStr += digitChinese[0];
                }
                if (fen !== 0) {
                    decimalStr += digitChinese[fen] + decimalUnit[1];
                }
            }
            let result = integerStr + decimalStr;
            if (isNegative) {
                result = '负' + result;
            }
            return result;
        },
        // 格式化时间
        formatterTime(time) {
            if (!time) return '';
            const date = new Date(time);
            return date.toLocaleString('zh-CN', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        }
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    min-height: 80%;
    box-sizing: border-box;
    font-family: fangsong;
    font-size: large;
}

.fixed-cards,
.dynamic-cards {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.clearfix {
    font-weight: bold;
}

.gap-line-border {
    padding: 0 10px;
    border: 1px dashed #ccc;
}

.gap-line {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: #ccc;
    margin-top: 10px;
}

.nameStyle {
    font-weight: bold;
    line-height: 4px;
}

.card {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
}

.card:hover {
    transform: scale(1.01);
}

.dynamic-cards:last-child {
    margin-bottom: 30px;
}

.card-content {
    padding: 20px;
    font-family: fangsong;
    word-break: break-word;
    /* 自动换行 */
}

.card p {
    margin: 10px 0;
    line-height: 1.6;
    word-break: break-word;
    /* 自动换行 */
}

.card strong {
    color: #333;
}

.card .el-image {
    border-radius: 5px;
}

.card-image {
    width: 100px;
    height: 100px;
    margin: 5px;
    border-radius: 5px;
    border: 1px solid #ccc;
    cursor: pointer;
    transition: transform 0.3s ease;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.form-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
}

.form-row p {
    flex: 1;
    min-width: calc(20% - 10px);
    /* 每行三个内容，减去间隙 */
    box-sizing: border-box;
    margin: 0;
}

.dynamic-cards .card {
    width: 100%;
}

@media (max-width: 768px) {
    .card {
        width: 100%;
    }

    .form-row {
        flex-direction: column;
    }

    .form-row p {
        min-width: 100%;
        /* 小屏幕下每行一个内容 */
    }
}
</style>